import { useEffect, useState } from "react";
import Footer from "../../../component/Footer";
import { Link } from "react-router-dom";
import Sidebar from "../AdminComp/Sidebar";
import BreadCrumb from "../AdminComp/BreadCrumb";
import { Eye } from "react-feather";
import { baseurl } from "../../../component/Baseurl";
import axios from "axios";
import AdminBookingNavbar from "./AdminBookingNavbar";

function AdminAgentReport() {
  const [agentData, setAgentData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch agent logins from API
  const fetchAgentLogins = async () => {
    try {
      const response = await axios.get(`${baseurl}/getAllAgentLogins`);
      console.log("API Response:", response.data);

      if (response.data.agents) {
        setAgentData(response.data.agents);
      } else {
        setAgentData([]);
      }
    } catch (error) {
      console.error("Error fetching agents:", error);
      setError("Failed to load agents.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAgentLogins();
  }, []);

  return (
    <>
      <div className="App" style={{ display: "flex" }}>
        <Sidebar />

        {/* Content area */}
        <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
          <div>
            <BreadCrumb />
            <div className="container-fluid">
<AdminBookingNavbar/>

              <div className="crdmain mb-2">
                <div className="d-flex justify-content-between align-items-center" style={{ width: "100%" }}>
                  <h2 className="chart-title mb-0">Agent Report</h2>
                </div>

                {/* Show loading or error */}
                {loading && <p>Loading agents...</p>}
                {error && <p className="text-danger">{error}</p>}

                {!loading && !error && (
                  <div className="row g-2 mt-0 mb-0">
                    <div className="col-md-12 p-2">
                      {/* Table */}
                      <div className="table-responsive classic-table">
                        <table className="table table-striped table-hover">
                          <thead className="table-header">
                            <tr>
                              <th>#</th>
                              <th>Agent ID</th>
                              <th>Name</th>
                              <th>Email</th>
                              <th>Phone</th>
                              <th>City</th>
                              <th>State</th>
                              <th>Country</th>
                              <th>Business Name</th>
                              <th>Status</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {agentData.length > 0 ? (
                              agentData.map((agent, index) => (
                                <tr key={agent.id}>
                                  <td>{index + 1}</td>
                                  <td>{agent.agent_unique_id}</td>
                                  <td>{agent.name}</td>
                                  <td>{agent.email}</td>
                                  <td>{agent.phone}</td>
                                  <td>{agent.city}</td>
                                  <td>{agent.state}</td>
                                  <td>{agent.country}</td>
                                  <td>{agent.business_name || "N/A"}</td>
                                  <td>
                                    <span className={`badge 
                                      ${agent.agent_status === "active" ? "bg-success" : "bg-danger"}
                                    `}>
                                      {agent.agent_status}
                                    </span>
                                  </td>
                                  <td>
                                    <span className="btn2 me-2" title="View Details">
                                      <Eye size={15} />
                                    </span>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="11" className="text-center">
                                  No agents found.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdminAgentReport;
